import { EMAIL } from "./constants";

import { useNavigate } from "react-router-dom";

export const openLinkInNewTab = (url) => {
  window.open(url, "_blank");
};

export const openEmail = (email) => {
  const mailtoLink = `mailto:${email}?subject=${EMAIL.subject}`;
  window.location.href = mailtoLink;
};

export const useNavigation = () => {
  const navigate = useNavigate();

  const goTo = (route) => {
    navigate(route);
  };

  return goTo;
};

// Projects with a custom `link` (e.g. a hub page) redirect there instead of the details page.
export const getProjectLink = (project) => project?.link || `/projects/${project?.slug}`;
